import { CSSInterpolation, CSSObject, Theme } from '@mui/material';
import { scrollbarStyles } from './scrollbarStyles';
import { themeVars } from './themeVars';

/**
 * Note that layout-specific styles like `html { height: 100% }` should be in layout components.
 */
export const cssBaseline: CSSObject | string | ((theme: Theme) => CSSInterpolation) = (theme) => ({
  // Make sizing more intuitive
  '*, *:before, *:after': {
    boxSizing: 'border-box',
  },

  // https://www.joshwcomeau.com/css/custom-css-reset/#two-remove-default-margin-3
  '*': {
    margin: 0,
  },

  html: {
    // Improve text rendering quality
    textRendering: 'optimizeLegibility',
    // Smoother fonts
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    // Prevent auto synthesis of bold / italic
    fontSynthesis: 'none',
    // Disable double-tap zoom for faster interaction
    touchAction: 'manipulation',
    // Prevent bidirectional text from affecting surrounding content
    unicodeBidi: 'isolate',
    // Enable smooth scrolling
    scrollBehavior: 'smooth',
  },

  '@media (prefers-reduced-motion: no-preference)': {
    html: {
      // Allow CSS transitions from height:0 to height:auto
      interpolateSize: 'allow-keywords',
    },
  },

  body: {
    // Disable font scaling adjustment on mobile
    textSizeAdjust: '100%',
    WebkitTextSizeAdjust: '100%',
  },

  // https://www.joshwcomeau.com/css/custom-css-reset/#eight-avoid-text-overflows-9
  'p, h1, h2, h3, h4, h5, h6': {
    overflowWrap: 'break-word',
  },

  ...scrollbarStyles(theme),

  // https://mui.com/material-ui/react-text-field/#performance
  '@keyframes mui-auto-fill': { from: { display: 'block' } },
  '@keyframes mui-auto-fill-cancel': { from: { display: 'block' } },

  '.Mui-focusVisible': {
    outline: `2px solid ${themeVars(theme).palette.border.focused}`,
    outlineOffset: -2,
  },

  '.Mds-invertedColors > *': {
    color: themeVars(theme).palette.text.primary,
  },

  '.Mds-svgAsset': {
    userSelect: 'none',
    display: 'inline-block',
    width: '100%',
    height: '100%',
    flexShrink: 0,
  },
});
